// extracted by mini-css-extract-plugin
export var background4 = "background4-module--background4--ba5a3";
export var box = "background4-module--box--a072c";
export var boxInner = "background4-module--boxInner--be2b6";
export var image = "background4-module--image--ce806";
export var inner = "background4-module--inner--2a5a5";
export var pretitle = "background4-module--pretitle--88712";